import { createSlice } from '@reduxjs/toolkit';

import type { PartnerInsightsState } from './types';

const initialState: null = null;

export const { reducer } = createSlice({
  name: 'partnerInsights',
  initialState: initialState as PartnerInsightsState | null,
  reducers: {},
});
